import { RadioGroupField } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const BooleanFieldInput: FC<FieldProps<'boolean'>> = (props) => {
  const { value, onChange } = props;

  return (
    <RadioGroupField
      value={value?.toString()}
      emphasised
      hiddenInput
      horizontal
      options={[
        {
          className: 'justify-center items-center',
          value: false.toString(),
          label: <UntitledIcon className="[&_path]:stroke-1" name="x.3" />,
        },
        {
          className: 'justify-center items-center',
          value: true.toString(),
          label: <UntitledIcon className="[&_path]:stroke-1" name="check" />,
        },
      ]}
      onChange={(value) => {
        let v: boolean | undefined = undefined;
        if (value === 'true') v = true;
        if (value === 'false') v = false;

        onChange(v);
      }}
    />
  );
};
